import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

/**
 * Компонент для обработки URL параметров в MiniApp
 * Обрабатывает параметры order_id и open_chat для автоматического открытия чата
 */
export const MiniAppHandler: React.FC = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    const orderId = searchParams.get('order_id')
    const openChat = searchParams.get('open_chat')
    
    console.log(`🔍 MiniAppHandler: orderId="${orderId}", openChat="${openChat}"`);

    if (orderId && openChat === 'true') {
      // Если нужно открыть чат по заказу - переходим на главную и сохраняем параметры
      navigate(`/miniapp/orders?order_id=${orderId}&open_chat=true`, { replace: true })
      
      // 🎯 УМНАЯ ПРОВЕРКА ГОТОВНОСТИ: Ждем пока ChatWidget будет готов
      const waitForChatWidget = () => {
        let attempts = 0
        const maxAttempts = 30 // Максимум 15 секунд (30 * 500ms)
        
        const checkWidget = () => {
          attempts++
          console.log(`🔍 Попытка ${attempts}: Проверяем готовность ChatWidget...`)
          
          // Проверяем наличие ChatWidget в глобальном контексте
          const chatWidget = (window as any).chatWidget
          
          if (chatWidget && typeof chatWidget.showOrderChat === 'function') {
            console.log(`💬 ✅ ChatWidget готов! Открываем чат для заказа: ${orderId}`)
            chatWidget.showOrderChat(orderId)
            
            // 🔥 ОЧИЩАЕМ URL ПАРАМЕТРЫ после успешного открытия чата
            setTimeout(() => {
              console.log(`🧹 Очищаем URL параметры после открытия чата`)
              navigate(`/miniapp/orders`, { replace: true })
            }, 2000) // Даем время чату открыться
            
            return
          }
          
          // Альтернативная проверка через событие
          if (attempts % 4 === 0) { // Каждые 2 секунды пробуем событие
            console.log(`🔄 Попытка ${attempts}: Пробуем через событие...`)
            window.dispatchEvent(new CustomEvent('openChatWidget', { 
              detail: { orderId: orderId, autoOpen: true }
            }))
            
            // 🔥 ОЧИЩАЕМ URL ПАРАМЕТРЫ после отправки события (на случай если событие сработает)
            if (attempts === 4) { // Только при первой попытке события
              setTimeout(() => {
                console.log(`🧹 Очищаем URL параметры после события`)
                navigate(`/miniapp/orders`, { replace: true })
              }, 3000)
            }
          }
          
          if (attempts < maxAttempts) {
            setTimeout(checkWidget, 500) // Проверяем каждые 500ms
          } else {
            console.error(`❌ ChatWidget не готов после ${maxAttempts} попыток`)
          }
        }
        
        // Начинаем проверку через 500ms
        setTimeout(checkWidget, 500)
      }
      
      waitForChatWidget()
      
    } else if (orderId) {
      // Если указан только order_id без open_chat - переходим к детальной странице заказа
      navigate(`/miniapp/orders/${orderId}`, { replace: true })
    } else {
      // Если нет специальных параметров, переходим к списку заказов
      navigate('/miniapp/orders', { replace: true })
    }
  }, [navigate, searchParams])

  // Показываем загрузку пока обрабатываем параметры
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      color: 'white'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255,255,255,0.3)',
          borderTop: '4px solid white',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem'
        }} />
        <p>Открываем диалог...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  )
}
